import React, { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { errMsg } from "../../lib/portfolio";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Card, CardContent } from "../../components/ui/card";

const LABELS = { open: "Not sent yet", in_review: "With architect", approved: "Approved", approved_as_noted: "Approved as noted", revise_resubmit: "Revise and resubmit", rejected: "Rejected" };

export function SubmittalPanel({ pid, manager }) {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ title: "", spec_section: "" });
  const [note, setNote] = useState("");
  const [error, setError] = useState(null);
  const load = useCallback(() => api.get(`/phase3/submittals/projects/${pid}`).then((r) => setRows(r.data)), [pid]);
  useEffect(() => { load(); }, [load]);
  const run = (p) => p.then(() => { setError(null); load(); }).catch((e) => setError(errMsg(e, "That did not work.")));
  const btn = "h-11 border-erf-borderCream";
  return (
    <Card className="ds-card border-erf-borderCream mt-6" data-testid="phase3-submittal-panel">
      <CardContent className="p-5 space-y-3 text-sm font-nav text-erf-dark">
        <h2 className="font-display font-semibold text-base md:text-lg">Submittals</h2>
        <p className="text-xs text-erf-dark/80">A review decision is not a professional seal or stamp.</p>
        {manager && (
          <form className="flex flex-wrap items-end gap-3" onSubmit={(e) => { e.preventDefault(); run(api.post(`/phase3/submittals/projects/${pid}`, f).then(() => setF({ title: "", spec_section: "" }))); }}>
            <label>Title<Input required value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} className="mt-1 h-11" data-testid="phase3-sub-title" /></label>
            <label>Spec section<Input value={f.spec_section} placeholder="08 41 13" onChange={(e) => setF({ ...f, spec_section: e.target.value })} className="mt-1 h-11 w-32" data-testid="phase3-sub-spec" /></label>
            <Button type="submit" className="h-11 bg-erf-dark text-[#FEFCF7]" data-testid="phase3-sub-add">Add submittal</Button>
          </form>
        )}
        <label className="block">Comments or reason (at least 10 characters when needed)<Input value={note} onChange={(e) => setNote(e.target.value)} className="mt-1 h-11" data-testid="phase3-sub-note" /></label>
        {error && <p role="alert" className="text-sm text-[#991B1B]" data-testid="phase3-sub-error">{error}</p>}
        <ul className="space-y-2">
          {rows.length === 0 && <li>No submittals yet.</li>}
          {rows.map((s) => (
            <li key={s.id} className="flex flex-wrap items-center gap-2" data-testid={`phase3-sub-${s.number}`}>
              <span className="mr-auto"><strong>{s.number}</strong> {s.title} · rev {s.revision} · {LABELS[s.state]}</span>
              {manager && s.state === "open" && <Button variant="outline" className={btn} onClick={() => run(api.post(`/phase3/submittals/${s.id}/submit`))} data-testid={`phase3-sub-submit-${s.number}`}>Send for review</Button>}
              {s.state === "in_review" && ["approved", "approved_as_noted", "revise_resubmit", "rejected"].map((d) => (
                <Button key={d} variant="outline" className={btn} onClick={() => run(api.post(`/phase3/submittals/${s.id}/review`, { decision: d, comments: note }))} data-testid={`phase3-sub-${d}-${s.number}`}>{LABELS[d]}</Button>
              ))}
              {manager && s.state === "revise_resubmit" && <Button variant="outline" className={btn} onClick={() => run(api.post(`/phase3/submittals/${s.id}/resubmit`, { reason: note }))} data-testid={`phase3-sub-resubmit-${s.number}`}>Resubmit</Button>}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
